import { AxiosPromise } from 'axios';
import { commonApi } from '@/services/api';
import { Resp } from '@/model/Resp';
import { getCouponCompanyId } from '@/utils/couponRulePayload';

const COUPON_RULE_ACTION = {
  list: 'cartsee.common.discount.rule.list',
  selectList: 'cartsee.common.discount.rule.select.list',
  get: 'cartsee.common.discount.rule.get',
  create: 'cartsee.common.discount.rule.create',
  shippingCountryOptions: 'cartsee.common.discount.rule.shipping.country.options',
  apiConfigQueryName: 'cartsee.common.discount.api-config.query-coupon-name',
} as const;

/**
 * 查询客户系统优惠券名称（规则ID失去焦点时调用）
 */
export async function queryCustomerCouponName(customerRuleId: string): Promise<string | null> {
  try {
    const res: any = await commonApi(
      { companyId: getCouponCompanyId(), customerRuleId },
      COUPON_RULE_ACTION.apiConfigQueryName
    );
    return res?.data?.data?.name || null;
  } catch {
    return null;
  }
}

export function getCouponList(params: {
  page?: number;
  pageSize?: number;
  keyword?: string;
  channel?: 'CAMPAIGN' | 'FLOW' | 'POPUP';
} = {}) {
  return commonApi(
    {
      companyId: getCouponCompanyId(),
      page: params.page || 1,
      pageSize: params.pageSize || 100,
      keyword: params.keyword,
      ...(params.channel ? { channel: params.channel } : {}),
    },
    params.channel ? COUPON_RULE_ACTION.selectList : COUPON_RULE_ACTION.list
  ) as AxiosPromise<Resp<{
    list: Array<{ couponId: string; couponName: string }>;
    supportedDiscountTypes?: string[];
  }>>;
}

export function getCouponDetail(params: { couponId: string }) {
  return commonApi(
    {
      companyId: getCouponCompanyId(),
      couponId: params.couponId,
    },
    COUPON_RULE_ACTION.get
  ) as AxiosPromise<Resp<Record<string, any>>>;
}

/** 当前 Shopify 店铺可配送、且可用于免运费折扣的国家。 */
export function getShippingCountryOptions() {
  return commonApi(
    { companyId: getCouponCompanyId() },
    COUPON_RULE_ACTION.shippingCountryOptions
  ) as AxiosPromise<Resp<Array<{
    countryAbbreviation: string;
    countryName?: string;
    country?: string;
  }>>>;
}

export function createCouponRule(rule: Record<string, any>) {
  return commonApi(rule, COUPON_RULE_ACTION.create) as AxiosPromise<
    Resp<{ couponId: string; ruleId?: number; versionNo?: number }>
  >;
}
